// Module
var code = "<div class=\"kp-zoomable-image_image\" ng-class=\"{zoomable: !$ctrl.isFullscreen, 'ultra-zoom': $ctrl.isUltraZoom}\" ng-click=\"$ctrl.openFullscreen()\" ng-mousemove=\"$ctrl.onMouseMoveForUltraZoom($event)\"></div>";
// Exports
var _module_exports =code;;
var path = '/ng-templates/src/commons/components/kp-zoomable-image/kp-zoomable-image.tpl.pug';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;